import { render, staticRenderFns } from "./ticket-types-statistics-modal.vue?vue&type=template&id=63142d9d&scoped=true"
import script from "./ticket-types-statistics-modal.vue?vue&type=script&lang=js"
export * from "./ticket-types-statistics-modal.vue?vue&type=script&lang=js"
import style0 from "./ticket-types-statistics-modal.vue?vue&type=style&index=0&id=63142d9d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63142d9d",
  null
  
)

export default component.exports